import {
  Container,
  Grid,
} from '@mui/material'

import Highlight from 'lib/components/Highlight'
import AnimatedTitle from 'lib/components/AnimatedTitle'
import FeatureCard from 'lib/components/FeatureCard'

import { GAMES } from './content'

const sectionStyles = {
  py: 10,
}

function Games() {
  const { ruanica, grimtile } = GAMES

  return (
    <Container
      component="section"
      id="games"
      sx={sectionStyles}
    >
      <AnimatedTitle>
        Our <Highlight>games</Highlight>
      </AnimatedTitle>

      <Grid container
        rowSpacing={5}
        columnSpacing={4}
        justifyContent="center"
        sx={{ mt: 2 }}
      >
        <FeatureCard
          title={grimtile.title}
          image={grimtile.image}
          imagePosition={grimtile.imagePosition}
          content={grimtile.content}
          cta={grimtile.cta}
        />
        <FeatureCard
          title={ruanica.title}
          image={ruanica.image}
          content={ruanica.content}
          cta={ruanica.cta}
        />
      </Grid>
    </Container>
  )
}

export default Games
